.typography {
  margin: 0;
  font-family: var(--font-family-base);
}

/* Display scale */
.display-2xl {
  font-size: var(--display-2xl-font-size);
  line-height: var(--display-2xl-line-height);
  letter-spacing: var(--display-2xl-letter-spacing);
}
.display-xl {
  font-size: var(--display-xl-font-size);
  line-height: var(--display-xl-line-height);
  letter-spacing: var(--display-xl-letter-spacing);
}
.display-lg {
  font-size: var(--display-lg-font-size);
  line-height: var(--display-lg-line-height);
  letter-spacing: var(--display-lg-letter-spacing);
}
.display-md {
  font-size: var(--display-md-font-size);
  line-height: var(--display-md-line-height);
  letter-spacing: var(--display-md-letter-spacing);
}
.display-sm {
  font-size: var(--display-sm-font-size);
  line-height: var(--display-sm-line-height);
  letter-spacing: var(--display-sm-letter-spacing);
}
.display-xs {
  font-size: var(--display-xs-font-size);
  line-height: var(--display-xs-line-height);
  letter-spacing: var(--display-xs-letter-spacing);
}

/* Text scale */
.text-xl {
  font-size: var(--text-xl-font-size);
  line-height: var(--text-xl-line-height);
  letter-spacing: var(--text-xl-letter-spacing);
}
.text-lg {
  font-size: var(--text-lg-font-size);
  line-height: var(--text-lg-line-height);
  letter-spacing: var(--text-lg-letter-spacing);
}
.text-md {
  font-size: var(--text-md-font-size);
  line-height: var(--text-md-line-height);
  letter-spacing: var(--text-md-letter-spacing);
}
.text-sm {
  font-size: var(--text-sm-font-size);
  line-height: var(--text-sm-line-height);
  letter-spacing: var(--text-sm-letter-spacing);
}
.text-xs {
  font-size: var(--text-xs-font-size);
  line-height: var(--text-xs-line-height);
  letter-spacing: var(--text-xs-letter-spacing);
}

/* Weight axis */
.regular {
  font-weight: var(--font-weight-regular);
}
.medium {
  font-weight: var(--font-weight-medium);
}
.semibold {
  font-weight: var(--font-weight-semibold);
}
.bold {
  font-weight: var(--font-weight-bold);
}
